import { isWorkspacePreview } from './workspacePreview';

const ANALYTICS_SESSION_KEY = 'analyticsSessionId';

const createSessionId = () => {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const ensureAnalyticsSessionId = () => {
  if (isWorkspacePreview()) return null;
  const existingSessionId = localStorage.getItem(ANALYTICS_SESSION_KEY);

  if (existingSessionId) {
    return existingSessionId;
  }

  const nextSessionId = createSessionId();
  localStorage.setItem(ANALYTICS_SESSION_KEY, nextSessionId);

  return nextSessionId;
};

export const getAnalyticsSessionId = () =>
  isWorkspacePreview() ? null : localStorage.getItem(ANALYTICS_SESSION_KEY);

export const clearAnalyticsSessionId = () => {
  localStorage.removeItem(ANALYTICS_SESSION_KEY);
};

export const sendAnalyticsSessionLog = ({ eventName, payload = {} }) => {
  if (isWorkspacePreview()) return;
  try {
    const sessionId = getAnalyticsSessionId();
    const authToken = localStorage.getItem('authToken');

    if (!sessionId || !authToken || !eventName) {
      return;
    }

    const requestBody = JSON.stringify({
      session_id: sessionId,
      event_name: eventName,
      payload,
      frontend_timestamp: new Date().toISOString()
    });

    const endpoint = `${process.env.REACT_APP_BACKEND_URL}/analytics/session-log`;

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: requestBody,
      keepalive: true
    }).catch(() => {
      // Ignore analytics delivery errors.
    });
  } catch (error) {
    // Ignore analytics delivery errors.
  }
};
